// @flow
import viFetchAdapter from '../viFetchAdapter';

export async function getCountBuildings(cid: string | number) {
  const { data } = await viFetchAdapter.get(`/pagewidget/getCountBuildings?cid=${cid}`);
  return data;
}

export async function getPageInfo(cid: string | number) {
  const { data } = await viFetchAdapter.get(`/pagewidget/getPageInfo?cid=${cid}`);
  return data;
}

export async function getFavoriteOffers(cid: string | number) {
  const { data } = await viFetchAdapter.get(`/pagewidget/fo?id=${cid}`);
  return data;
}

export async function getSections(cid: string | number) {
  const { data } = await viFetchAdapter.get(`/pagewidget/getSections?id=${cid}`);
  return data;
}

export async function loadKindbuildings(cid: string | number) {
  const { data } = await viFetchAdapter.get(`/pagewidget/loadKindbuildings?id=${cid}`);
  return data;
}

export async function loadCities(cid: string | number) {
  const { data } = await viFetchAdapter.get(`/pagewidget/Loadcities?id=${cid}`);
  return data;
}

export async function loadSectors(cid: string | number) {
  const { data } = await viFetchAdapter.get(`/pagewidget/loadsectors?id=${cid}`);
  return data;
}



// WEBPACK FOOTER //
// ./src/libs/pagewidget.js